import { reverse } from "@reactivated";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { IWishListLine, WishListLines } from "../models/catalogue";
import { IProductAPIURL } from "../models/nominals";
import { check } from "../models/utils";
import { CSRF_HEADER, fetchJson, getCSRFToken } from "../utils/ajax";
import { PromiseMutex } from "../utils/mutex";

// The server adds a product to this list when its basket line is removed.
export const LIST_PREVIOUSLY_IN_BASKET = "previously-in-basket";

export const listLines = async (
    wishListCode: string,
): Promise<readonly IWishListLine[]> => {
    const mutex = new PromiseMutex<readonly IWishListLine[]>(
        `wishlist-products-list-${wishListCode}`,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = fetchJson(
            reverse("wishlisttype-line-list", { code: wishListCode }),
        ).then((body) => {
            return check(WishListLines.decode(body));
        });
        mutex.setPromise(loading);
    }
    return loading;
};

export const addLine = async (
    wishListCode: string,
    lineURL: IProductAPIURL,
): Promise<void> => {
    const window = getWindow();
    const origin = window?.location.origin || "";
    const data = {
        list_type: `${origin}${reverse("wishlisttype-detail", { code: wishListCode })}`,
        product: lineURL,
    };
    await fetchJson(reverse("wishlisttype-line-list", { code: wishListCode }), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            [CSRF_HEADER]: await getCSRFToken(),
        },
        body: JSON.stringify(data),
    });
};

export const removeLine = async (lineURL: string): Promise<void> => {
    await fetchJson(lineURL, {
        method: "DELETE",
        headers: {
            [CSRF_HEADER]: await getCSRFToken(),
        },
    });
};
